@if (product.isDirectlyAvailable || product.isAvailableLater || product.isStockAvailableLater) {
<div class="more-available-text">
	@if (product.isAvailableLater || product.isStockAvailableLater) {
	<strong i18n="@@product.more.available">Available from</strong>
	<strong>{{ getAvailableLaterDate() | customDate:'d MMM' }}</strong>
	}

	@else {
	<strong i18n="@@product.later.available">More available from</strong>
	<strong>{{ getAvailableLaterDate() | customDate:'d MMM' }}</strong>
	}
</div>
}
